import React from 'react'
// import { Button, Menu, MenuItem } from 'react-mdl';

export const getCurrentBlockColor = state => {
  const mark = state.marks.find(mark => mark.type === 'color')
  return mark && mark.data.get('color')
}

// const updateState = (state, type) => state
//   .transform()
//   .setBlock({
//     type,
//   })
//   .focus()
//   .apply();

// const ColorSelector = ({ state, onChange }) => (
//   <span style={{ position: 'relative' }}>
//     <Button id="paragraph-selector-menu">{getCurrentBlockType(state)}</Button>
//     <Menu target="paragraph-selector-menu">
//       {NODE_TYPES.map(type => (
//         <MenuItem key={type} onClick={() => onChange(updateState(state, type))}>
//           {NODE_NAMES[type]}
//         </MenuItem>
//       ))}
//     </Menu>
//   </span>
// );

const Plugin = () => ({
  schema: {
    marks: {
      color: ({ children, mark: { data } }) => (
        <span style={{ color: data.get('color') }}>{children}</span>
      ),
    },
  },
})

export { Plugin as ColorSelectorPlugin } //, ColorSelector };



// WEBPACK FOOTER //
// ./src/components/Editor/plugins/TextColorSelector.js